import { Fund } from '../types';
import { EditableFund } from '../funds/schemas/fundSchema';
import { useCreate } from '@refinedev/core';

export const useCreateFund = () => {
  const { mutateAsync, isLoading, isError } = useCreate<Fund>();

  const createFund = async (fund: EditableFund) => {
    return mutateAsync({
      resource: 'funds',
      values: fund,
    });
  };

  return {
    createFund,
    isLoading: isLoading,
    isError: isError,
  };
};
